import React, { lazy, Suspense } from 'react';
import ProposalApp from './proposalApp';
import PdfApp from './pdfApp';
import LibraryApp from './libraryApp';
import ShapeScratchApp from './shapeScratchApp';
import CardBankApp from './cardBankApp';

const WebViewerApp = lazy(() => import('./webViewerApp'));
const WebPreviewApp = lazy(() => import('./webPreviewApp'));
const WebReviewApp = lazy(() => import('./webReviewApp'));
const WebTemplateAdminApp = lazy(() => import('./webTemplateAdminApp'));
const WebEditorApp = lazy(() => import('./webEditorApp'));
const SectionPreviewApp = lazy(() => import('./sectionPreviewApp'));
const AdminApp = lazy(() => import('./adminApp'));
const HelpApp = lazy(() => import('./help/HelpApp'));

const AppSelector = () => {
  const searchParams = new URLSearchParams(document.location.search);
  const isPdfGen = !!searchParams.get('generate_pdf');
  // Aperçu d'une section en iframe (?tid=<id>&section_preview=1) : rendu seul,
  // sans éditeur ni collaboration. Testé en premier pour qu'aucune autre route
  // ne puisse monter l'éditeur complet dans l'iframe.
  const isSectionPreview = !!searchParams.get('section_preview');
  // Vue bibliothèque plein écran (embarquée en iframe dans le costing).
  const isLibrary = searchParams.get('view') === 'library';
  // Vue "composer une forme" (embarquée en iframe dans le costing, cf.
  // shapeScratchApp.jsx).
  const isShapeScratch = searchParams.get('view') === 'shape-scratch';
  // Banque de modèles de Carte info (embarquée en iframe dans le costing, cf.
  // cardBankApp.jsx).
  const isCardBank = searchParams.get('view') === 'card-bank';
  const { pathname } = document.location;

  // Aide de l'éditeur (/help/<mode>/…), ouverte dans un nouvel onglet : testée avant les paramètres d'URL.
  if (pathname === '/help' || pathname.startsWith('/help/')) {
    return (
      <Suspense fallback={null}>
        <HelpApp />
      </Suspense>
    );
  }

  if (isSectionPreview) {
    return (
      <Suspense fallback={null}>
        <SectionPreviewApp />
      </Suspense>
    );
  }
  if (isPdfGen) return <PdfApp />;
  if (isLibrary) return <LibraryApp />;
  if (isShapeScratch) return <ShapeScratchApp />;
  if (isCardBank) return <CardBankApp />;

  if (pathname.startsWith('/view/')) {
    return (
      <Suspense fallback={null}>
        <WebViewerApp />
      </Suspense>
    );
  }

  if (pathname.startsWith('/preview/')) {
    return (
      <Suspense fallback={null}>
        <WebPreviewApp />
      </Suspense>
    );
  }

  if (pathname.startsWith('/review/')) {
    return (
      <Suspense fallback={null}>
        <WebReviewApp />
      </Suspense>
    );
  }

  if (pathname.startsWith('/web-templates')) {
    return (
      <Suspense fallback={null}>
        <WebTemplateAdminApp />
      </Suspense>
    );
  }

  if (pathname.startsWith('/web-editor/')) {
    return (
      <Suspense fallback={null}>
        <WebEditorApp />
      </Suspense>
    );
  }

  if (pathname.startsWith('/admin')) {
    return (
      <Suspense fallback={null}>
        <AdminApp />
      </Suspense>
    );
  }

  return <ProposalApp />;
};

export default AppSelector;
